<template>
  <List :mapState="'papeleriaRequests'" :allDispatch="'papeleriaRequestsAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/papeleria/requests/list.vue